import { render } from "./Portfolio.vue?vue&type=template&id=d2470f18"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
script.render = render

export default script